import styled from 'styled-components';
import ds from 'designsystem';
import React from 'react';
import PropTypes from 'prop-types';
import globeImage from 'common/images/globe.png';
import LanguageImage from './LanguageImage';
import LanguageArrow from './LanguageArrow';

const LanguagesButtonWrapper = styled.a`
  position: relative;
  display: block;
  padding-top: calc(${ds.get('metrics.xs')} / 2);
  background-color: ${ds.brand('white')};
  height: ${ds.get('navSection.navHeight')};
  cursor: pointer;
  transition-duration: 0.2s;
  opacity: ${({ hidden }) => (hidden ? '0' : '1')};
`;

const LanguagesButton = ({ onClick, hidden }) => (
  <LanguagesButtonWrapper
    hidden={hidden}
    onClick={event => onClick(event)}
  >
    <LanguageImage src={globeImage} />
    <LanguageArrow />
  </LanguagesButtonWrapper>
);
LanguagesButton.propTypes = {
  onClick: PropTypes.func,
  hidden: PropTypes.bool,
};
LanguagesButton.defaultProps = {
  onClick: () => {},
  hidden: false,
};
export default LanguagesButton;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Languages/LanguagesButton.jsx